'use strict';

var React = require('react');
var component = require('../Heading/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const CellTextSub = React.forwardRef(({ text, sub, maxWidth = '100%', size = 'm', textOverflow = 'ellipsis', ...props }, ref) => size === 's' ? (React__default.default.createElement(styles.Styled.Container, { ...props, maxWidth: maxWidth, ref: ref },
    React__default.default.createElement(component.Heading, { variant: "heading-5", textOverflow: textOverflow, overflow: "hidden" }, text),
    React__default.default.createElement(styles.Styled.SubText, { forwardedAs: "p", variant: "body-lighter", textOverflow: textOverflow }, sub))) : (React__default.default.createElement(styles.Styled.Container, { ...props, maxWidth: maxWidth, ref: ref },
    React__default.default.createElement(component.Heading, { variant: "heading-4", textOverflow: textOverflow, overflow: "hidden" }, text),
    React__default.default.createElement(styles.Styled.SubHeading, { variant: "heading-5", textOverflow: textOverflow }, sub))));

exports.CellTextSub = CellTextSub;
//# sourceMappingURL=component.js.map
